var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pdf",class:{'page-back-head': !(_vm.employerConfig && _vm.employerConfig.hidTitle)}},[(!(_vm.employerConfig && _vm.employerConfig.hidTitle))?_c('u-page-back',{attrs:{"title":"报告详情"}}):_vm._e(),_c('pdfPreview',{attrs:{"url":_vm.pdfUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }